import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React  from "react";

import { useAddCourseMutation,useGetQualificationListQuery} from "../../../Services/api";

export default function Create() {
    
    const notify = () => '';
    const { register, handleSubmit, formState: { errors }} = useForm();

    const [addCourse,isLoading] = useAddCourseMutation();
    const onSubmit = (values,e) => {

        const formData = new FormData();
        formData.append('cgroup', values.cgroup);
        formData.append('course_name', values.course_name);
        formData.append('short_name', values.short_name);
        // formData.append('elements', values.elements);
        formData.append('course_type', values.course_type);
        formData.append('file', values.file[0]);
        formData.append('type', 'course');
       
        ///
        addCourse(formData)
        .unwrap()
        .then((payload) => {
            if (payload.status) {
                e.target.reset()
                toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error.data.message)
        });
        notify();
    }; 
    const { 
        data: getQualificationList        
    } = useGetQualificationListQuery({  params:''});
    return (
        <div className="tab-pane fade" id="bordered-justified-profile" role="tabpanel" aria-labelledby="profile-tab" >
            <section className="section">
                <div className="card">
                    <div className="card-body">
                    <h5 className="card-title">Add Course</h5>
                    <form onSubmit={handleSubmit(onSubmit)} >
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Qualification</label>
                            <div className="col-sm-10">
                               <select  {...register("cgroup",{required:true})} className="form-control" >
                                 <option value="">Select Qualification</option>                                           

                                {                            
                                getQualificationList?.data?.map((item) => {
                                    return (
                                        <option key={item.qid} value={item.qid}>{item.qualification}</option>                                           
                                        )
                                    })
                                }
                                </select>
                                {errors.cgroup && <span  className="text-danger">course group is required</span>}

                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">course Name</label>
                            <div className="col-sm-10">
                                <input type="name" {...register("course_name",{required:true})} className="form-control" />
                                {errors.course_name && <span  className="text-danger">course name is required</span>}

                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">short name</label>
                            <div className="col-sm-10">
                                <input type="name" {...register("short_name",{required:true})} className="form-control" />
                                {errors.short_name && <span  className="text-danger">short name is required</span>}

                            </div>
                        </div>
                        {/* <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">short name</label>
                            <div className="col-sm-10">
                                <input type="name" {...register("elements",{required:true})} className="form-control" />
                                {errors.elements && <span  className="text-danger">elements is required</span>}

                            </div>
                        </div> */}
                        
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Course Type</label>
                            <div className="col-sm-10">
                                <select  {...register("course_type",{required:true})} className="form-control" >
                                 <option value="">Select Type</option>  
                                 <option value="1">paid</option>                                           
                                 <option value="2">free</option>  
                                </select>
                                {errors.course_type && <span  className="text-danger">course type is required</span>}
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">course image</label>
                            <div className="col-sm-10">
                                <input type="file" {...register("file",{required:true})} className="form-control" />
                                <span className="text-danger">{errors.file?.message}</span>
                                {errors.file && <span  className="text-danger">course image  is required</span>}

                            </div>
                        </div>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label"></label>
                            <div className="col-sm-10">
                            {isLoading.status !='pending' ? 
                                                
                                <button type="submit" className="btn btn-warning w-100" >Add Course</button>
                                 :
                                 <button type="submit" className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                            }
                            </div>
                        </div>
                    </form>
                    </div>
                </div>
            </section>
        </div>
    );
}